<template>
    <div class="jetlympic-list">
       <div class="header">
            <img src="@/assets/jetlympic/logo.png" />
       </div>
       <div class="list">
        <div class="item" v-for="item in list" :key="item.id" @click="handleItemClick(item)">
            <div class="title" v-html="$t(`jetlympic.shuttle.${item.id}`)"></div>
        </div>
       </div>
       <img class="banner" src="@/assets/jetlympic/banner.png" />
       <div class="footer">POWER BY BMBsports</div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        list: [
          {
            id: 'text_1',
            newsId: '248269',
          },
          {
            id: 'text_2',
            newsId: '248271',
          },
          {
            id: 'text_3',
            newsId: '248272',
          },
        ],
      };
    },
    mounted() {
      
    },
    methods: {
      handleItemClick(item) {
        this.$router.push({ path: `/account/news-detail/${item.newsId}` });
      }
    },
};
</script>

<style scoped lang="scss">
.jetlympic-list{
    width: 100vw;
    height: 100vh;
    background-color: #00A7FF;
    box-sizing: border-box;
    padding: 0 18px;
    .header{
        text-align: center;
        padding-top: 14px;
        img{
            width: 280px;
        }
    }
    .list{
      position: relative;
      z-index: 3;
      margin-top: 24px;
      .item{
        height: 48px;
        background-color: #fff;
        color: #00A7FF;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 3px;
        margin-bottom: 12px;
        .title{
          height: 100%;
          // \n 换行
          white-space: pre-wrap;
          line-height: 23px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          span{
            font-size: 14px;
          }
        }
      }
    }
    .footer{
      position: absolute;
      bottom: 18px;
      width: 100%;
        text-align: center;
        color: rgba(255, 255, 255, 0.4);
        font-size: 13px;
        margin-top: 18px;
    }
    .banner{
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      opacity: 0.6;
      z-index: 1;
    }
}
</style>
